<div class="unauthorized-container" style="text-wrap: nowrap;" da="no-access-page">
  <ng-container>
    <ukg-illustrative-message illustrative-icon="empty" orientation="vertical">
      <img slot="illustration" src="" alt="" />
      <h5 slot="title">{{ 'COMMON.MISSING_COMPANY_AND_PAYGROUP_QUALIFIERS_NEW_HEADER' | translate }}</h5>
      {{ 'COMMON.MISSING_COMPANY_AND_PAYGROUP_QUALIFIERS_NEW_LINE1' | translate }} <br/> <br/>
      {{ 'COMMON.MISSING_COMPANY_AND_PAYGROUP_QUALIFIERS_NEW_LINE2' | translate }} <br/> <br/>
      <a (click)="this.openRoleAdministrationGuide($event)" href="#">{{ 'COMMON.TAX_PSG_GUIDE' | translate }}</a>
    </ukg-illustrative-message>
  </ng-container>
</div>
